import * as React from 'react';

export function SvgMicrosoftPowerpoint(props: any) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_14_226)">
        <path
          d="M14.0931 13.45L12.6977 3H12.5935C7.51968 3.01513 3.4102 7.21194 3.39539 12.3936V12.5L14.0931 13.45Z"
          fill="#ED6C47"
        />
        <path
          d="M12.8018 3H12.6976V12.5L17.3488 14.4L22 12.5V12.3936C21.9851 7.21194 17.8757 3.01513 12.8018 3Z"
          fill="#FF8F6B"
        />
        <path
          d="M22 12.5V12.6045C21.9855 17.7873 17.875 21.9851 12.8 22H12.5954C7.52041 21.9851 3.40995 17.7873 3.39539 12.6045V12.5H22Z"
          fill="#D35230"
        />
        <path
          opacity="0.1"
          d="M13.1628 7.66924V17.8057C13.1605 18.158 12.9515 18.4744 12.6326 18.6085C12.5311 18.6523 12.4219 18.675 12.3117 18.675H5.59075C5.46051 18.523 5.33494 18.3615 5.21865 18.2C4.03367 16.5856 3.39385 14.6221 3.3954 12.6045V12.3955C3.39268 10.5757 3.91346 8.79514 4.89307 7.27499C4.9954 7.11349 5.10237 6.95199 5.21865 6.79999H12.3117C12.7803 6.80362 13.1593 7.19068 13.1628 7.66924Z"
          fill="black"
        />
        <path
          opacity="0.2"
          d="M12.6977 8.14425V18.2807C12.6977 18.3933 12.6756 18.5048 12.6326 18.6085C12.5013 18.9342 12.1915 19.1476 11.8466 19.15H6.01401C5.86685 18.9974 5.72564 18.839 5.59075 18.675C5.46051 18.523 5.33494 18.3615 5.21865 18.2C4.03367 16.5856 3.39385 14.6221 3.3954 12.6045V12.3955C3.39268 10.5757 3.91346 8.79514 4.89307 7.27499H11.8466C12.3152 7.27861 12.6942 7.66567 12.6977 8.14425Z"
          fill="black"
        />
        <path
          opacity="0.2"
          d="M12.6977 8.14427V17.3308C12.6942 17.8093 12.3152 18.1964 11.8466 18.2H5.21865C4.03367 16.5857 3.39385 14.6221 3.3954 12.6045V12.3955C3.39268 10.5757 3.91346 8.79517 4.89307 7.27502H11.8466C12.3152 7.27863 12.6942 7.66569 12.6977 8.14427Z"
          fill="black"
        />
        <path
          opacity="0.2"
          d="M12.2326 8.14427V17.3308C12.2291 17.8093 11.8501 18.1964 11.3814 18.2H5.21865C4.03367 16.5857 3.39385 14.6221 3.3954 12.6045V12.3955C3.39268 10.5757 3.91346 8.79517 4.89307 7.27502H11.3814C11.8501 7.27863 12.2291 7.66569 12.2326 8.14427Z"
          fill="black"
        />
        <path
          d="M2.85255 7.27499H11.38C11.8509 7.27499 12.2325 7.66481 12.2325 8.14566V16.8543C12.2325 17.3352 11.8508 17.725 11.38 17.725H2.85255C2.38171 17.725 2 17.3352 2 16.8543V8.14566C2 7.66481 2.38171 7.27499 2.85255 7.27499Z"
          fill="url(#paint0_linear_14_226)"
        />
        <path
          d="M7.20927 9.59726C7.76438 9.55901 8.31471 9.72368 8.76183 10.0618C9.13476 10.4018 9.33403 10.898 9.3023 11.4075C9.30839 11.7617 9.21597 12.1104 9.03579 12.4131C8.85337 12.7105 8.59055 12.9478 8.27904 13.0961C7.92292 13.2653 7.53356 13.3488 7.1409 13.3403H6.0623V15.3875H4.95764V9.59726H7.20927ZM6.06137 12.4558H7.01207C7.31346 12.4784 7.61251 12.3873 7.85254 12.1998C8.05107 12.0053 8.15512 11.731 8.13672 11.4507C8.13672 10.8126 7.77362 10.4936 7.04743 10.4936H6.06138V12.4558H6.06137Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_14_226"
          x1="3.7776"
          y1="6.59467"
          x2="10.6678"
          y2="18.2798"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CA4C28" />
          <stop offset="0.5" stopColor="#C5401E" />
          <stop offset="1" stopColor="#B62F14" />
        </linearGradient>
        <clipPath id="clip0_14_226">
          <rect
            width="20"
            height="19"
            fill="white"
            transform="translate(2 3)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
